<template>
  <div class="cmpnt-box">
      <div class="lmy-city-content" style="padding-top: 0.5rem;">
        <p class="hot-city" style='color: #000;font-size: 16px;font-weight: bold;'>热门城市</p>
        <div v-if="data.from==1">
          <table class="hot-city-table">
            <tr v-for="item in cnCityList">
              <td v-for="city in item" @click="select(city,1)">{{city.Name}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div @click="cancel" class="closeBtn" style="width: 0.6rem;margin: 0.5rem auto;">
        <img src="../../../assets/img/close.png" alt="">
      </div>
  </div>
</template>
<script>

  export default {
    name: 'city',
    props: {
      cityData: {
        type: Object,
        default: () => {
          return {}
        }
      }

    },
    data() {
      return {
        data: {},
        cnCityList: JSON.parse(this.dao.get("getPackageHotCity")),
      }
    },
    watch: {
      cityData(val) {
        this.data = val;
      },
      data:{
        handler:function(val,oldval){
          this.cnCityList = JSON.parse(this.dao.get("getPackageHotCity")),
          this.initList();
          document.getElementsByClassName('cmpnt-box')[0].scrollTop = 0;
        },
        deep:true//对象内部的属性监听，也叫深度监听
      },
    },
    methods: {
      cancel() {
        this.key='';
        this.cityList='';
        this.$emit('cancel')
      },
      select(item,from) {
        this.key='';
        this.cityList='';
        this.$emit('select', item, from)
      },
      initList() {
        //国内
        var resultcn = [];
        for (var i = 0, len = this.cnCityList.length; i < len; i += 3) {
          resultcn.push(this.cnCityList.slice(i, i + 3));
        }
        this.cnCityList = resultcn;
      },
    },
    mounted() {
      this.data = this.cityData;
      this.initList();
    },
  }


</script>



// WEBPACK FOOTER //
// src/components/free/cmpnt/city.vue